import gql from 'graphql-tag';

export const createMOCEventAcknowledgement = gql`
  mutation createMOCEventAcknowledgement($input: MOCEventAckInput) {
    createMOCEventAcknowledgement(input: $input) {
      id
      Contact {
        id
        firstName
        lastName
      }
      acknowledged
      comments
      completedDt
      createdBy
      createdAt
      updater
      updatedAt
      deletedAt
      version
    }
  }
`;
